import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getInvestorCustomDetails } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { GetShareholderCustomDetailRes } from '@dealstack/shared/lib/generated';

type Options = Omit<
	UseQueryOptions<
		ApiV1.Response<GetShareholderCustomDetailRes>,
		unknown,
		GetShareholderCustomDetailRes,
		[string, string | undefined]
	>,
	'queryKey' | 'queryFn' | 'select'
>;

export const useInvestorCustomDetails = (
	kycWorkflowId?: string,
	options?: Options
): UseQueryResult<GetShareholderCustomDetailRes | undefined, unknown> => {
	const { ...queryOptions } = options || {};

	return useQuery({
		queryKey: [API_PATHS.SHAREHOLDER_CUSTOM_DETAIL_GET, kycWorkflowId],
		queryFn: () => getInvestorCustomDetails(kycWorkflowId ? { kycWorkflowId } : undefined),
		select: (data: ApiV1.Response<GetShareholderCustomDetailRes>) => data.payload,
		...queryOptions,
	});
};
